import React, { useState } from "react";
import { Container, Divider, Snackbar, Alert, TextField, Card, Button, Typography, Grid, CardActions, LinearProgress, Skeleton} from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";

import { useDisableOrgMutation, useOrgChangePasswordMutation, useOrgDetailsQuery, useOrgDeleteMutation } from "services/org";
import { v4 as uuidv4 } from 'uuid'


const OrgDetails = (props) => {
    
    const navi = useNavigate();
    const {userId} = useParams();
    const [disableButton, setDisableButton] = useState(false);
    const [ requestId, setRequestId ] = useState('');
    const [ newPassword, setChangePassword] = useState('');
    const [ showChangePassword, setShowChangePassword ] = useState(false);
    const [ orgDeleteMutation ] = useOrgDeleteMutation(); 
    const [sb, setSB] = useState({open: false, message: '', duration: 3000, severity: 'error'});
    const [ changePassword ] = useOrgChangePasswordMutation(); 
    const [ disableUser ] = useDisableOrgMutation(); 

    
    const handleClose = () => {
        setSB({...sb, open: false});
      };


    const handleCancel = () =>{
        navi("/orgs/list")
    }

    
    const handleChangePassword = () =>{
        setDisableButton(true);
        console.log(orgDetails.email)
        changePassword({
            email: orgDetails.email,
            password: newPassword
        })
        .unwrap()
        .then(result=>{
            console.log(result);
            setSB({...sb, open: true, message: "Password Changed", severity:"success"});
            setDisableButton(false);
        })
        .catch(err=>{
            setSB({...sb, open: true, message: err.message});
            setDisableButton(false);
        })
    }

    const handleDisableUser = () =>{
        setDisableButton(true);
        disableUser({
            email: orgDetails.username,
            id: orgDetails.id,
            disable: orgDetails.status
        })
        .unwrap()
        .then(result=>{
            setSB({...sb, open: true, message: orgDetails.status ? "User Disabled" : "User Enabled", severity:"warning"});
            var i = uuidv4();
            setRequestId(i);
            setTimeout(()=>{
                setDisableButton(false);
            }, 5000)
        })
        .catch(err=>{
            setSB({...sb, open: true, message: err.message});
            setDisableButton(false);
        })
    }

    const handleDelete = () =>{
        setDisableButton(true)
        console.log(userId);
        orgDeleteMutation({email:orgDetails.email, id: userId})
        .unwrap()
        .then(result=>{
            setDisableButton(false);
            navi("/orgs/list")
        })
        .catch(err=>{
            setDisableButton(false);
            navi("/orgs/list")
        })
        
    }

    const {orgDetails, userStatus, userLoading, fetching} = useOrgDetailsQuery(
        {
            id: userId, 
            requestId: requestId
        }, 
        {
            skip: !userId,
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                orgDetails: data || {},
                userStatus: status,
                userLoading: isLoading,
                fetching: isFetching
            })
        }
    );

    // const {orgDetails, orgStatus, orgLoading, orgFetching} = useOrgDetailsQuery({id: userDetails.orgId}, 
    //     {
    //         skip: !userDetails.id,
    //         selectFromResult: ({ data, status, isLoading, isFetching }) => ({
    //             orgDetails: data || {},
    //             orgStatus: status,
    //             orgLoading: isLoading,
    //             orgFetching: isFetching
    //         })
    //     }
    // );


    return (
        <React.Fragment>
            <CommonListHeader value = {{title: `Organization: ${orgDetails.name}`, description: "You are viewing organization details. To edit click edit button"}} />
            <Container maxWidth={'md'}>
                <Card>
                    {disableButton?<LinearProgress />:''}
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Organization Name</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Typography variant="body1">{orgDetails?.name || <Skeleton />}</Typography>
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">E-Mail</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Typography variant="body1">{orgDetails?.email || <Skeleton />}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Phone</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Typography variant="body1">{orgDetails?.phone || <Skeleton />}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Address</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Typography variant="body1">{orgDetails?.address || <Skeleton />}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1"></Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Typography variant="body1">{`${orgDetails?.city} ${orgDetails.state}, ${orgDetails.zip}` || <Skeleton />}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Status</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Typography variant="body1">{orgDetails?.status? 'ACTIVE' : 'INACTIVE'}</Typography>
                        </Grid>
                    </Grid>

                    {showChangePassword ? 
                        <React.Fragment>
                            <Divider sx={{margin: "10px"}}/>
                            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                            
                                <Grid item md={2}>
                                    <Typography variant="body1">Change Password</Typography>
                                </Grid>
                                <Grid item md={5}>
                                    <TextField 
                                        variant="outlined" 
                                        fullWidth
                                        onChange={(event)=>setChangePassword(event.target.value)}
                                        value={newPassword || ''}  
                                    />
                                </Grid>
                                <Grid item md={4} sx={{marginLeft: "10px"}}>
                                    <Button 
                                        disabled={newPassword.length === 0}
                                        variant="contained" 
                                        onClick={()=>handleChangePassword()}
                                    >
                                        Submit
                                    </Button>
                                    <Button variant="outlined" onClick={() => setShowChangePassword(false)} sx={{marginLeft: "10px"}}>Cancel</Button>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    : ''}
                    
                    <CardActions sx={{padding: "15px"}}>
                       
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                        <Typography sx={{flexGrow: 1}} />
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleDisableUser()}
                            color={'warning'}
                        >
                            {orgDetails.status ? 'Disable User' : 'Enable User'}
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => setShowChangePassword(true)}
                            color={'warning'}
                        >
                            Change Password
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleDelete()}
                            color={'warning'}
                        >
                            delete
                        </Button>
                    </CardActions>
                </Card>
            </Container>
            <Snackbar
                color='error'
                open={sb.open}
                autoHideDuration={sb.duration}
                onClose={handleClose}
                message={sb.message}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleClose}
                    severity={sb.severity}
                    variant="filled"
                sx={{ width: '100%' }}
                >
                    {sb.message}
                </Alert>
            </Snackbar>
        </React.Fragment>
    )

    
}

export default OrgDetails;